import { Button, Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './BuildsPage.module.less';
import { Fragment, useEffect, useState } from 'react';
import { ProductReleaseDto, ProductStatus, ReleaseChannel, ProjectStatusDto } from 'api';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'redux/store';
import { getProjectBuilds, getProjectStatus } from 'redux/reducers/projectsSlice';
import { useHistory, useParams } from 'react-router-dom';
import { FileZipFilled } from '@ant-design/icons';
import BuildModal from './Modal';
import moment from 'moment';
type ParamsProps = {
	projectId: string;
	releaseChannelId: string;
};
type BuildDetails = {
	obbFiles: ProductReleaseDto[];
} & ProductReleaseDto;
export default function BuildDetailsPage() {
	const { t } = useTranslation();
	const [buildModalVisible, setBuildModalVisible] = useState(false);
	const [buildInfo, setBuildInfo] = useState<BuildDetails>();
	const [buildIsUploading, setBuildIsUploading] = useState(false);
	const { projectId, releaseChannelId } = useParams<ParamsProps>();
	const [projectStatus, setProjectStatus] = useState<ProjectStatusDto>();
	const dispatch: AppDispatch = useDispatch();
	const history = useHistory();
	useEffect(() => {
		dispatch(
			getProjectBuilds({
				projectId: parseInt(projectId),
				releaseChannel: parseInt(releaseChannelId),
			}),
		).then((result) => {
			if (getProjectBuilds.fulfilled.match(result)) {
				//@ts-ignore
				const buildDetails: BuildDetails = result.payload.data.find(
					(release: ProductReleaseDto) => (release?.fileName || '').indexOf('apk') >= 0,
				);
				//@ts-ignore
				buildDetails.obbFiles = result.payload.data.filter(
					(release: ProductReleaseDto) => (release?.fileName || '').indexOf('apk') < 0,
				);
				setBuildInfo(buildDetails);
			}
		});
	}, [releaseChannelId]);

	useEffect(() => {
		initProjectStatus();
	}, []);

	const initProjectStatus = async () => {
		const result = await dispatch(getProjectStatus(parseInt(projectId)));
		if (getProjectStatus.fulfilled.match(result)) {
			setProjectStatus(result.payload);
		}
	};

	const promoteBuildToStore = () => {};
	const handleActionClick = () => {
		if (buildInfo?.releaseChannelId !== ReleaseChannel.Store) {
			setBuildModalVisible(true);
		} else {
			promoteBuildToStore();
		}
	};
	const getActionButton = () => {
		if (buildInfo?.releaseChannelId == ReleaseChannel.Store && projectStatus?.status == ProductStatus.Released) {
			return;
		}
		return (
			<div className={styles.buttonContainer}>
				<Button
					loading={buildIsUploading}
					type="primary"
					onClick={handleActionClick}
					disabled={
						buildInfo?.releaseChannelId == ReleaseChannel.Store && projectStatus?.status != ProductStatus.ApprovedForStore
					}
				>
					{buildInfo?.releaseChannelId != ReleaseChannel.Store && t('buildDetailsPage.UpdateButton')}
					{buildInfo?.releaseChannelId == ReleaseChannel.Store && t('projectBuildsPage.PromoteToStore')}
				</Button>
			</div>
		);
	};
	return (
		<div className={styles.projectBuildsContainer}>
			<div className="page-head">
				<div>
					<h2 className="h2">
						{buildInfo?.releaseChannelId !== undefined && (
							<>
								{ReleaseChannel[buildInfo.releaseChannelId].toString()} {t('buildDetailsPage.Header')}
							</>
						)}
					</h2>
				</div>
			</div>
			<Card
				title={
					<>
						<FileZipFilled />
						{buildInfo?.buildName}
					</>
				}
				extra={buildInfo != undefined && projectStatus != undefined && getActionButton()}
				bodyStyle={{ backgroundColor: '#fafafa' }}
			>
				<Descriptions layout="vertical" style={{ background: '#fafafa' }}>
					<Descriptions.Item label={t('buildDetailsPage.details.id')}>{buildInfo?.id}</Descriptions.Item>
					<Descriptions.Item label={t('buildDetailsPage.details.version')}>{buildInfo?.version}</Descriptions.Item>
					<Descriptions.Item label={t('buildDetailsPage.details.created')}>
						{moment.parseZone(buildInfo?.createdDate).local().format('MM-DD-YYYY h:mmA z')}
					</Descriptions.Item>
					<Descriptions.Item label={t('buildDetailsPage.details.size')}>
						{((buildInfo?.size || 0) * 0.000001).toFixed(2) + ' MB'}
					</Descriptions.Item>
					<Descriptions.Item label={t('buildDetailsPage.details.versionCode')}>{buildInfo?.versionCode}</Descriptions.Item>
					<Descriptions.Item label={t('buildDetailsPage.details.fileName')}>{buildInfo?.fileName}</Descriptions.Item>
					<Descriptions.Item label={t('buildDetailsPage.details.obbFile')}>
						{buildInfo?.obbFiles?.map((obb, index, array) => (
							<Fragment key={index}>
								{obb.fileName}
								{index != array.length - 1 && <br />}
							</Fragment>
						))}
					</Descriptions.Item>
				</Descriptions>
			</Card>
			<BuildModal
				setVisible={(visible: boolean) => setBuildModalVisible(visible)}
				afterSubmit={() => history.push(`/project/${projectId}/builds`)}
				isUploading={setBuildIsUploading}
				projectId={parseInt(projectId)}
				projectStatus={projectStatus?.status}
				visible={buildModalVisible}
				buildInfo={buildInfo}
				existingBuilds={[]}
			/>
		</div>
	);
}
